import * as React from 'react';
import { Input, Button } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { MultiSelect } from 'primereact/multiselect';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';
import { Close } from '@material-ui/icons';
import Typography from '@material-ui/core/Typography';
import Box from "@material-ui/core/Box";

interface TabPanelProps {
    children?: React.ReactNode;
    dir?: string;
    index: any;
    value: number;
}
export function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            className={value !== index ? "" : "d-inline-flex w100p"}
            hidden={value !== index}
            {...other}
        >
            {value === index && (
                <div className="w100p">{children}</div>
            )}
        </div>
    );
}

interface ModalProps {
    openModal?: any;
    titleText?: string;
    showClose?: boolean;
    body?: any;
    closeModal?: any;
    ActionClick?: any;
    ButtonText?: string;
    smallerModal?: boolean;
}
export class MiddleModal extends React.Component<ModalProps> {
    render() {
        return (
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={this.props.smallerModal ? "Model ModalPop smaller" : "Model ModalPop"}
                open={this.props.openModal}
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={this.props.openModal}>
                    <div className={this.props.smallerModal ? "ModelPaper2 ModalPopBody m10mr10 ModalLogin smaller" : "ModelPaper2 ModalPopBody m10mr10 ModalLogin"}>
                        <div className="d-flex">
                            <div className="mr-auto p-2"><h4 className="TitleModal">{this.props.titleText}</h4></div>
                            {this.props.showClose ? <div className="ml-auto floatRight cursor-pointer"> <Close className=" mr-1 cursor-pointer" onClick={this.props.closeModal} /></div> : <></>}
                        </div>
                        <div className={this.props.smallerModal ? "BodyModal mb-2 smaller" : "BodyModal mb-2"}>
                            <div className="overflowxHidden">
                                {this.props.body}
                            </div>
                        </div>
                        <div className="ButtonsBottom">
                            <div className="floatLeft mb-2 ml-3">

                                <Button className="mr-2 ButtonsModal AddBtn" onClick={this.props.ActionClick}>{this.props.ButtonText} </Button>
                            </div>
                        </div>
                    </div>
                </Fade>
            </Modal>

        )
    }
};


interface FiltrationButtonPagesProps {
    filterOn?: any;
    onClick?: any;
}
export class FiltrationButtonPages extends React.Component<FiltrationButtonPagesProps> {
    render() {
        return (
            <div className="d-inline-flex divRight">
                <Button className={this.props.filterOn ? " ButtonsClicked2 ml-2 divRight" : " ButtonsClicked ml-2 divRight"} onClick={this.props.onClick}>
                    <FontAwesomeIcon icon={faFilter} className="cursor-pointer mr-2" />
                    <FontAwesomeIcon icon={faChevronDown} className="cursor-pointer mr-2" />
                </Button>
            </div>

        )
    }
};
interface FilterBarProps {
    body?: any;
    handleClose?: any;
    theme?: any;
    filterFirstTable?: any;
    sidebar?: boolean;
    isSmallSize?: boolean;
    filterContact?: string;
    filterKeyWord?: string;
    noSearch?: boolean;
}

export class FilterBar extends React.Component<FilterBarProps> {
    render() {
        return (
            <div>
                <div className="d-flex" >
                    <div className={`filterBar ${this.props.isSmallSize ? " " : "w100p"} `}>
                        <div className=" filterBarBackground">
                            <div className="divLeft">
                                <FontAwesomeIcon icon={faFilter} className="ml-3 mt-2 filterBtn" />
                            </div>
                            <div className="d-flex">
                                <Input
                                    type="text"
                                    name="filterContact"
                                    id="filterInput"
                                    bsSize="lg"
                                    className="filterInput filterInputinPages"
                                    placeholder={this.props.filterKeyWord}
                                    value={this.props.filterContact}
                                    onKeyUp={this.ReloadTable}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={`${this.props.isSmallSize ? " " : "ml-auto "} p-2 `}>
                        <div>
                            {this.props.body}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    ReloadTable = (e: any) => {
        if (e.keyCode === 13 || (!e.target.value && e.keyCode === 8))
            this.props.filterFirstTable(e);
    }
};
interface FilterMultiSelectProps {
    placeholder: string;
    value?: any[];
    options?: any[];
    onChange?: any;
    id?: any;
    inpages?: any;
}
export class FilterMultiSelect extends React.Component<FilterMultiSelectProps> {
    render() {
        return (
            <MultiSelect
                id={this.props.id}
                filter={true}
                className={this.props.inpages ? "ShowSearch2 d-block ShowSearch NoBordersFilter multiselect-custom" : "d-block ShowSearch multiselect-custom mb-2"}
                value={this.props.value}
                options={this.props.options}
                onChange={this.props.onChange}
                //placeholder={ReturnPlaceHolderStatement(this.props.placeholder, this.props.value, this.props.options)}
                maxSelectedLabels={0}
                fixedPlaceholder
            />
        )
    }
};
export function ReturnPlaceHolderStatement(title: string, multiSelectValue: any[], Options: any[]) {
    try {
        if (multiSelectValue.length === Options.length) return `All ${title} selected`
        else if (multiSelectValue && multiSelectValue.length > 0)
            return `${multiSelectValue.length} ${title} selected`;
        else
            return title;
    } catch (e) {
        return title;
    }
}
